import {serverSideTranslations} from 'next-i18next/serverSideTranslations';

import ClinicPositionsLayout from '@/src/jobPortal/clinicPositions/containers/ClinicPositions';

const MyPositionsPage = () => {
  return <ClinicPositionsLayout />;
};

export default MyPositionsPage;

export const getStaticProps = async ({locale}) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});
